import {
  SubscriptionInterval,
  SubscriptionTier,
  SubscriptionType,
} from '@prisma/client'
import { Stripe } from 'stripe'

/**
 * Stripe subscription status constants
 * These match the official Stripe API values to ensure consistency
 */
const STRIPE_SUBSCRIPTION_STATUS = {
  ACTIVE: 'active' as const,
  CANCELED: 'canceled' as const,
  INCOMPLETE: 'incomplete' as const,
  INCOMPLETE_EXPIRED: 'incomplete_expired' as const,
  PAST_DUE: 'past_due' as const,
  PAUSED: 'paused' as const,
  TRIALING: 'trialing' as const,
  UNPAID: 'unpaid' as const,
} as const

/**
 * Active subscription statuses that indicate the subscription is currently active
 * and should be considered valid for billing purposes
 */
export const STRIPE_ACTIVE_SUBSCRIPTION_STATUSES: Stripe.Subscription.Status[] =
  [
    STRIPE_SUBSCRIPTION_STATUS.ACTIVE,
    STRIPE_SUBSCRIPTION_STATUS.TRIALING,
    STRIPE_SUBSCRIPTION_STATUS.PAST_DUE,
    STRIPE_SUBSCRIPTION_STATUS.INCOMPLETE,
  ]

/**
 * Subscription statuses that indicate the subscription is no longer active
 */
export const STRIPE_INACTIVE_SUBSCRIPTION_STATUSES: Stripe.Subscription.Status[] =
  [
    STRIPE_SUBSCRIPTION_STATUS.CANCELED,
    STRIPE_SUBSCRIPTION_STATUS.INCOMPLETE_EXPIRED,
    STRIPE_SUBSCRIPTION_STATUS.PAUSED,
    STRIPE_SUBSCRIPTION_STATUS.UNPAID,
  ]

export const STRIPE_PRICE_MAPPING_2 = {
  [process.env.NEXT_PUBLIC_STRIPE_SUPPLIER_BRONZE_YEARLY!]: {
    interval: SubscriptionInterval.YEARLY,
    type: SubscriptionType.SUPPLIER,
    tier: SubscriptionTier.BRONZE,
    legacy: false,
  },
  [process.env.NEXT_PUBLIC_STRIPE_SUPPLIER_BRONZE_MONTHLY!]: {
    interval: SubscriptionInterval.MONTHLY,
    type: SubscriptionType.SUPPLIER,
    tier: SubscriptionTier.BRONZE,
    legacy: false,
  },
  [process.env.NEXT_PUBLIC_STRIPE_SUPPLIER_SILVER_YEARLY!]: {
    interval: SubscriptionInterval.YEARLY,
    type: SubscriptionType.SUPPLIER,
    tier: SubscriptionTier.SILVER,
    legacy: false,
  },
  [process.env.NEXT_PUBLIC_STRIPE_SUPPLIER_SILVER_MONTHLY!]: {
    interval: SubscriptionInterval.MONTHLY,
    type: SubscriptionType.SUPPLIER,
    tier: SubscriptionTier.SILVER,
    legacy: false,
  },
  [process.env.NEXT_PUBLIC_STRIPE_SUPPLIER_GOLD_YEARLY!]: {
    interval: SubscriptionInterval.YEARLY,
    type: SubscriptionType.SUPPLIER,
    tier: SubscriptionTier.GOLD,
    legacy: false,
  },
  [process.env.NEXT_PUBLIC_STRIPE_SUPPLIER_GOLD_MONTHLY!]: {
    interval: SubscriptionInterval.MONTHLY,
    type: SubscriptionType.SUPPLIER,
    tier: SubscriptionTier.GOLD,
    legacy: false,
  },
  [process.env.NEXT_PUBLIC_STRIPE_VENUE_BRONZE_YEARLY!]: {
    interval: SubscriptionInterval.YEARLY,
    type: SubscriptionType.VENUE,
    tier: SubscriptionTier.BRONZE,
    legacy: false,
  },
  [process.env.NEXT_PUBLIC_STRIPE_VENUE_BRONZE_MONTHLY!]: {
    interval: SubscriptionInterval.MONTHLY,
    type: SubscriptionType.VENUE,
    tier: SubscriptionTier.BRONZE,
    legacy: false,
  },
  [process.env.NEXT_PUBLIC_STRIPE_VENUE_SILVER_YEARLY!]: {
    interval: SubscriptionInterval.YEARLY,
    type: SubscriptionType.VENUE,
    tier: SubscriptionTier.SILVER,
    legacy: false,
  },
  [process.env.NEXT_PUBLIC_STRIPE_VENUE_SILVER_MONTHLY!]: {
    interval: SubscriptionInterval.MONTHLY,
    type: SubscriptionType.VENUE,
    tier: SubscriptionTier.SILVER,
    legacy: false,
  },
  [process.env.NEXT_PUBLIC_STRIPE_VENUE_GOLD_YEARLY!]: {
    interval: SubscriptionInterval.YEARLY,
    type: SubscriptionType.VENUE,
    tier: SubscriptionTier.GOLD,
    legacy: false,
  },
  [process.env.NEXT_PUBLIC_STRIPE_VENUE_GOLD_MONTHLY!]: {
    interval: SubscriptionInterval.MONTHLY,
    type: SubscriptionType.VENUE,
    tier: SubscriptionTier.GOLD,
    legacy: false,
  },
  [process.env.NEW_STRIPE_PRICE_ID!]: {
    interval: SubscriptionInterval.MONTHLY,
    type: SubscriptionType.SUPPLIER,
    tier: SubscriptionTier.BRONZE,
    legacy: true,
  },
  [process.env.NEW_STRIPE_VENUE_PRICE_ID!]: {
    interval: SubscriptionInterval.MONTHLY,
    type: SubscriptionType.VENUE,
    tier: SubscriptionTier.BRONZE,
    legacy: true,
  },
}
